module.exports = "/_next/static/images/window_minimize-65254854ef10dffb25f6e07614188fbf.svg";